export const JackpotDataList = [
  {
    resultDate: "07/29/2024",
    results: [
      {
        winningDigit: "94",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "17",
      },
    ],
  },
  {
    resultDate: "07/30/2024",
    results: [
      {
        winningDigit: "46",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "55",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "87",
      },
    ],
  },
  {
    resultDate: "07/31/2024",
    results: [
      {
        winningDigit: "58",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "05",
      },
    ],
  },
  {
    resultDate: "08/01/2024",
    results: [
      {
        winningDigit: "71",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "22",
      },
    ],
  },
  {
    resultDate: "08/02/2024",
    results: [
      {
        winningDigit: "23",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "55",
      },
    ],
  },
  {
    resultDate: "08/03/2024",
    results: [
      {
        winningDigit: "09",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "82",
      },
    ],
  },
  {
    resultDate: "08/04/2024",
    results: [
      {
        winningDigit: "71",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "58",
      },
    ],
  },
  {
    resultDate: "08/05/2024",
    results: [
      {
        winningDigit: "27",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "97",
      },
    ],
  },
  {
    resultDate: "08/06/2024",
    results: [
      {
        winningDigit: "78",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "70",
      },
    ],
  },
  {
    resultDate: "08/07/2024",
    results: [
      {
        winningDigit: "45",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "12",
      },
    ],
  },
  {
    resultDate: "08/08/2024",
    results: [
      {
        winningDigit: "74",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "98",
      },
    ],
  },
  {
    resultDate: "08/09/2024",
    results: [
      {
        winningDigit: "46",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "55",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "05",
      },
    ],
  },
  {
    resultDate: "08/10/2024",
    results: [
      {
        winningDigit: "21",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "09",
      },
    ],
  },
  {
    resultDate: "08/11/2024",
    results: [
      {
        winningDigit: "79",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "05",
      },
    ],
  },
  {
    resultDate: "08/12/2024",
    results: [
      {
        winningDigit: "57",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "30",
      },
    ],
  },
  {
    resultDate: "08/13/2024",
    results: [
      {
        winningDigit: "11",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "55",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "42",
      },
    ],
  },
  {
    resultDate: "08/14/2024",
    results: [
      {
        winningDigit: "21",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "37",
      },
    ],
  },
  {
    resultDate: "08/15/2024",
    results: [
      {
        winningDigit: "62",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "40",
      },
    ],
  },
  {
    resultDate: "08/16/2024",
    results: [
      {
        winningDigit: "26",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "62",
      },
    ],
  },
  {
    resultDate: "08/17/2024",
    results: [
      {
        winningDigit: "90",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "61",
      },
    ],
  },
  {
    resultDate: "08/18/2024",
    results: [
      {
        winningDigit: "69",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "93",
      },
    ],
  },
  {
    resultDate: "08/19/2024",
    results: [
      {
        winningDigit: "56",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "93",
      },
    ],
  },
  {
    resultDate: "08/20/2024",
    results: [
      {
        winningDigit: "15",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "69",
      },
    ],
  },
  {
    resultDate: "08/21/2024",
    results: [
      {
        winningDigit: "78",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "74",
      },
    ],
  },
  {
    resultDate: "08/22/2024",
    results: [
      {
        winningDigit: "75",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "28",
      },
    ],
  },
  {
    resultDate: "08/23/2024",
    results: [
      {
        winningDigit: "35",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "06",
      },
    ],
  },
  {
    resultDate: "08/24/2024",
    results: [
      {
        winningDigit: "21",
      },
      {
        winningDigit: "55",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "72",
      },
    ],
  },
  {
    resultDate: "08/25/2024",
    results: [
      {
        winningDigit: "51",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "07",
      },
    ],
  },
  {
    resultDate: "08/26/2024",
    results: [
      {
        winningDigit: "75",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "44",
      },
    ],
  },
  {
    resultDate: "08/27/2024",
    results: [
      {
        winningDigit: "51",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "93",
      },
    ],
  },
  {
    resultDate: "08/28/2024",
    results: [
      {
        winningDigit: "11",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "93",
      },
    ],
  },
  {
    resultDate: "08/29/2024",
    results: [
      {
        winningDigit: "51",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "45",
      },
    ],
  },
  {
    resultDate: "08/30/2024",
    results: [
      {
        winningDigit: "21",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "33",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "19",
      },
    ],
  },
  {
    resultDate: "08/31/2024",
    results: [
      {
        winningDigit: "07",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "57",
      },
    ],
  },
  {
    resultDate: "09/01/2024",
    results: [
      {
        winningDigit: "79",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "39",
      },
    ],
  },
  {
    resultDate: "09/02/2024",
    results: [
      {
        winningDigit: "57",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "25",
      },
    ],
  },
  {
    resultDate: "09/03/2024",
    results: [
      {
        winningDigit: "67",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "33",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "56",
      },
    ],
  },
  {
    resultDate: "09/04/2024",
    results: [
      {
        winningDigit: "19",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "20",
      },
    ],
  },
  {
    resultDate: "09/05/2024",
    results: [
      {
        winningDigit: "82",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "64",
      },
    ],
  },
  {
    resultDate: "09/06/2024",
    results: [
      {
        winningDigit: "80",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "51",
      },
    ],
  },
  {
    resultDate: "09/07/2024",
    results: [
      {
        winningDigit: "44",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "62",
      },
    ],
  },
  {
    resultDate: "09/08/2024",
    results: [
      {
        winningDigit: "65",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "48",
      },
    ],
  },
  {
    resultDate: "09/09/2024",
    results: [
      {
        winningDigit: "29",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "09",
      },
    ],
  },
  {
    resultDate: "09/10/2024",
    results: [
      {
        winningDigit: "37",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "16",
      },
    ],
  },
  {
    resultDate: "09/11/2024",
    results: [
      {
        winningDigit: "75",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "84",
      },
    ],
  },
  {
    resultDate: "09/12/2024",
    results: [
      {
        winningDigit: "14",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "74",
      },
    ],
  },
  {
    resultDate: "09/13/2024",
    results: [
      {
        winningDigit: "44",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "55",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "86",
      },
    ],
  },
  {
    resultDate: "09/14/2024",
    results: [
      {
        winningDigit: "62",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "45",
      },
    ],
  },
  {
    resultDate: "09/15/2024",
    results: [
      {
        winningDigit: "31",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "28",
      },
    ],
  },
  {
    resultDate: "09/16/2024",
    results: [
      {
        winningDigit: "83",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "09",
      },
    ],
  },
  {
    resultDate: "09/17/2024",
    results: [
      {
        winningDigit: "27",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "18",
      },
    ],
  },
  {
    resultDate: "09/18/2024",
    results: [
      {
        winningDigit: "16",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "64",
      },
    ],
  },
  {
    resultDate: "09/19/2024",
    results: [
      {
        winningDigit: "65",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "33",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "21",
      },
    ],
  },
  {
    resultDate: "09/20/2024",
    results: [
      {
        winningDigit: "32",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "34",
      },
    ],
  },
  {
    resultDate: "09/21/2024",
    results: [
      {
        winningDigit: "85",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "11",
      },
    ],
  },
  {
    resultDate: "09/22/2024",
    results: [
      {
        winningDigit: "05",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "57",
      },
    ],
  },
  {
    resultDate: "09/23/2024",
    results: [
      {
        winningDigit: "17",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "94",
      },
    ],
  },
  {
    resultDate: "09/24/2024",
    results: [
      {
        winningDigit: "48",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "82",
      },
    ],
  },
  {
    resultDate: "09/25/2024",
    results: [
      {
        winningDigit: "81",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "32",
      },
    ],
  },
  {
    resultDate: "09/26/2024",
    results: [
      {
        winningDigit: "92",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "03",
      },
    ],
  },
  {
    resultDate: "09/27/2024",
    results: [
      {
        winningDigit: "27",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "41",
      },
    ],
  },
  {
    resultDate: "09/28/2024",
    results: [
      {
        winningDigit: "14",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "89",
      },
    ],
  },
  {
    resultDate: "09/29/2024",
    results: [
      {
        winningDigit: "42",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "44",
      },
    ],
  },
  {
    resultDate: "09/30/2024",
    results: [
      {
        winningDigit: "51",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "69",
      },
    ],
  },
  {
    resultDate: "10/01/2024",
    results: [
      {
        winningDigit: "53",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "17",
      },
    ],
  },
  {
    resultDate: "10/02/2024",
    results: [
      {
        winningDigit: "89",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "95",
      },
    ],
  },
  {
    resultDate: "10/03/2024",
    results: [
      {
        winningDigit: "12",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "33",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "79",
      },
    ],
  },
  {
    resultDate: "10/04/2024",
    results: [
      {
        winningDigit: "62",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "13",
      },
    ],
  },
  {
    resultDate: "10/05/2024",
    results: [
      {
        winningDigit: "43",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "02",
      },
    ],
  },
  {
    resultDate: "10/06/2024",
    results: [
      {
        winningDigit: "24",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "55",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "27",
      },
    ],
  },
  {
    resultDate: "10/07/2024",
    results: [
      {
        winningDigit: "07",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "16",
      },
    ],
  },
  {
    resultDate: "10/08/2024",
    results: [
      {
        winningDigit: "45",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "38",
      },
    ],
  },
  {
    resultDate: "10/09/2024",
    results: [
      {
        winningDigit: "38",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "74",
      },
    ],
  },
  {
    resultDate: "10/10/2024",
    results: [
      {
        winningDigit: "13",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "42",
      },
    ],
  },
  {
    resultDate: "10/11/2024",
    results: [
      {
        winningDigit: "20",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "54",
      },
    ],
  },
  {
    resultDate: "10/12/2024",
    results: [
      {
        winningDigit: "53",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "55",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "99",
      },
    ],
  },
  {
    resultDate: "10/13/2024",
    results: [
      {
        winningDigit: "39",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "38",
      },
    ],
  },
  {
    resultDate: "10/14/2024",
    results: [
      {
        winningDigit: "01",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "51",
      },
    ],
  },
  {
    resultDate: "10/15/2024",
    results: [
      {
        winningDigit: "60",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "47",
      },
    ],
  },
  {
    resultDate: "10/16/2024",
    results: [
      {
        winningDigit: "34",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "25",
      },
    ],
  },
  {
    resultDate: "10/17/2024",
    results: [
      {
        winningDigit: "18",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "46",
      },
    ],
  },
  {
    resultDate: "10/18/2024",
    results: [
      {
        winningDigit: "25",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "34",
      },
    ],
  },
  {
    resultDate: "10/19/2024",
    results: [
      {
        winningDigit: "03",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "92",
      },
    ],
  },
  {
    resultDate: "10/20/2024",
    results: [
      {
        winningDigit: "21",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "76",
      },
    ],
  },
  {
    resultDate: "10/21/2024",
    results: [
      {
        winningDigit: "15",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "14",
      },
    ],
  },
  {
    resultDate: "10/22/2024",
    results: [
      {
        winningDigit: "08",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "75",
      },
    ],
  },
  {
    resultDate: "10/23/2024",
    results: [
      {
        winningDigit: "23",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "02",
      },
    ],
  },
  {
    resultDate: "10/24/2024",
    results: [
      {
        winningDigit: "90",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "34",
      },
    ],
  },
  {
    resultDate: "10/25/2024",
    results: [
      {
        winningDigit: "12",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "62",
      },
    ],
  },
  {
    resultDate: "10/26/2024",
    results: [
      {
        winningDigit: "24",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "09",
      },
    ],
  },
  {
    resultDate: "10/27/2024",
    results: [
      {
        winningDigit: "49",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "54",
      },
    ],
  },
  {
    resultDate: "10/28/2024",
    results: [
      {
        winningDigit: "21",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "15",
      },
    ],
  },
  {
    resultDate: "10/29/2024",
    results: [
      {
        winningDigit: "13",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "19",
      },
    ],
  },
  {
    resultDate: "10/30/2024",
    results: [
      {
        winningDigit: "65",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "02",
      },
    ],
  },
  {
    resultDate: "10/31/2024",
    results: [
      {
        winningDigit: "61",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "96",
      },
    ],
  },
  {
    resultDate: "11/01/2024",
    results: [
      {
        winningDigit: "84",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "05",
      },
    ],
  },
  {
    resultDate: "11/02/2024",
    results: [
      {
        winningDigit: "28",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "33",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "34",
      },
    ],
  },
  {
    resultDate: "11/03/2024",
    results: [
      {
        winningDigit: "15",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "52",
      },
    ],
  },
  {
    resultDate: "11/04/2024",
    results: [
      {
        winningDigit: "48",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "73",
      },
    ],
  },
  {
    resultDate: "11/05/2024",
    results: [
      {
        winningDigit: "05",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "94",
      },
    ],
  },
  {
    resultDate: "11/06/2024",
    results: [
      {
        winningDigit: "62",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "86",
      },
    ],
  },
  {
    resultDate: "11/07/2024",
    results: [
      {
        winningDigit: "81",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "53",
      },
    ],
  },
  {
    resultDate: "11/08/2024",
    results: [
      {
        winningDigit: "57",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "22",
      },
    ],
  },
  {
    resultDate: "11/09/2024",
    results: [
      {
        winningDigit: "21",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "34",
      },
    ],
  },
  {
    resultDate: "11/10/2024",
    results: [
      {
        winningDigit: "35",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "67",
      },
    ],
  },
  {
    resultDate: "11/11/2024",
    results: [
      {
        winningDigit: "13",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "14",
      },
    ],
  },
  {
    resultDate: "11/12/2024",
    results: [
      {
        winningDigit: "06",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "23",
      },
    ],
  },
  {
    resultDate: "11/13/2024",
    results: [
      {
        winningDigit: "71",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "01",
      },
    ],
  },
  {
    resultDate: "11/14/2024",
    results: [
      {
        winningDigit: "36",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "25",
      },
    ],
  },
  {
    resultDate: "11/15/2024",
    results: [
      {
        winningDigit: "47",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "99",
      },
    ],
  },
  {
    resultDate: "11/16/2024",
    results: [
      {
        winningDigit: "91",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "53",
      },
    ],
  },
  {
    resultDate: "11/17/2024",
    results: [
      {
        winningDigit: "30",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "60",
      },
    ],
  },
  {
    resultDate: "11/18/2024",
    results: [
      {
        winningDigit: "79",
      },
      {
        winningDigit: "55",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "84",
      },
    ],
  },
  {
    resultDate: "11/19/2024",
    results: [
      {
        winningDigit: "14",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "40",
      },
    ],
  },
  {
    resultDate: "11/20/2024",
    results: [
      {
        winningDigit: "33",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "81",
      },
    ],
  },
  {
    resultDate: "11/21/2024",
    results: [
      {
        winningDigit: "32",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "71",
      },
    ],
  },
  {
    resultDate: "11/22/2024",
    results: [
      {
        winningDigit: "02",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "94",
      },
    ],
  },
  {
    resultDate: "11/23/2024",
    results: [
      {
        winningDigit: "25",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "94",
      },
    ],
  },
  {
    resultDate: "11/24/2024",
    results: [
      {
        winningDigit: "43",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "37",
      },
    ],
  },
  {
    resultDate: "11/25/2024",
    results: [
      {
        winningDigit: "06",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "14",
      },
    ],
  },
  {
    resultDate: "11/26/2024",
    results: [
      {
        winningDigit: "21",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "85",
      },
    ],
  },
  {
    resultDate: "11/27/2024",
    results: [
      {
        winningDigit: "10",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "08",
      },
    ],
  },
  {
    resultDate: "11/28/2024",
    results: [
      {
        winningDigit: "35",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "56",
      },
    ],
  },
  {
    resultDate: "11/29/2024",
    results: [
      {
        winningDigit: "14",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "95",
      },
    ],
  },
  {
    resultDate: "11/30/2024",
    results: [
      {
        winningDigit: "58",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "79",
      },
    ],
  },
  {
    resultDate: "12/01/2024",
    results: [
      {
        winningDigit: "53",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "64",
      },
    ],
  },
  {
    resultDate: "12/02/2024",
    results: [
      {
        winningDigit: "11",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "73",
      },
    ],
  },
  {
    resultDate: "12/03/2024",
    results: [
      {
        winningDigit: "98",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "56",
      },
    ],
  },
  {
    resultDate: "12/04/2024",
    results: [
      {
        winningDigit: "38",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "42",
      },
    ],
  },
  {
    resultDate: "12/05/2024",
    results: [
      {
        winningDigit: "29",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "58",
      },
    ],
  },
  {
    resultDate: "12/06/2024",
    results: [
      {
        winningDigit: "01",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "51",
      },
    ],
  },
  {
    resultDate: "12/07/2024",
    results: [
      {
        winningDigit: "53",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "78",
      },
    ],
  },
  {
    resultDate: "12/08/2024",
    results: [
      {
        winningDigit: "06",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "45",
      },
    ],
  },
  {
    resultDate: "12/09/2024",
    results: [
      {
        winningDigit: "17",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "24",
      },
    ],
  },
  {
    resultDate: "12/10/2024",
    results: [
      {
        winningDigit: "25",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "06",
      },
    ],
  },
  {
    resultDate: "12/11/2024",
    results: [
      {
        winningDigit: "48",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "39",
      },
    ],
  },
  {
    resultDate: "12/12/2024",
    results: [
      {
        winningDigit: "26",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "19",
      },
    ],
  },
  {
    resultDate: "12/13/2024",
    results: [
      {
        winningDigit: "18",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "81",
      },
    ],
  },
  {
    resultDate: "12/14/2024",
    results: [
      {
        winningDigit: "29",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "33",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "66",
      },
    ],
  },
  {
    resultDate: "12/15/2024",
    results: [
      {
        winningDigit: "13",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "55",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "92",
      },
    ],
  },
  {
    resultDate: "12/16/2024",
    results: [
      {
        winningDigit: "04",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "54",
      },
    ],
  },
  {
    resultDate: "12/17/2024",
    results: [
      {
        winningDigit: "35",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "06",
      },
    ],
  },
  {
    resultDate: "12/18/2024",
    results: [
      {
        winningDigit: "51",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "89",
      },
    ],
  },
  {
    resultDate: "12/19/2024",
    results: [
      {
        winningDigit: "85",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "10",
      },
    ],
  },
  {
    resultDate: "12/20/2024",
    results: [
      {
        winningDigit: "03",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "96",
      },
    ],
  },
  {
    resultDate: "12/21/2024",
    results: [
      {
        winningDigit: "19",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "01",
      },
    ],
  },
  {
    resultDate: "12/22/2024",
    results: [
      {
        winningDigit: "25",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "62",
      },
    ],
  },
  {
    resultDate: "12/23/2024",
    results: [
      {
        winningDigit: "74",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "34",
      },
    ],
  },
  {
    resultDate: "12/24/2024",
    results: [
      {
        winningDigit: "41",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "56",
      },
    ],
  },
  {
    resultDate: "12/25/2024",
    results: [
      {
        winningDigit: "32",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "97",
      },
    ],
  },
  {
    resultDate: "12/26/2024",
    results: [
      {
        winningDigit: "18",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "95",
      },
    ],
  },
  {
    resultDate: "12/27/2024",
    results: [
      {
        winningDigit: "04",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "20",
      },
    ],
  },
  {
    resultDate: "12/28/2024",
    results: [
      {
        winningDigit: "31",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "86",
      },
    ],
  },
  {
    resultDate: "12/29/2024",
    results: [
      {
        winningDigit: "87",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "71",
      },
    ],
  },
  {
    resultDate: "12/30/2024",
    results: [
      {
        winningDigit: "47",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "37",
      },
    ],
  },
  {
    resultDate: "12/31/2024",
    results: [
      {
        winningDigit: "29",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "92",
      },
    ],
  },
  {
    resultDate: "01/01/2025",
    results: [
      {
        winningDigit: "57",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "12",
      },
    ],
  },
  {
    resultDate: "01/02/2025",
    results: [
      {
        winningDigit: "45",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "16",
      },
    ],
  },
  {
    resultDate: "01/03/2025",
    results: [
      {
        winningDigit: "02",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "98",
      },
    ],
  },
  {
    resultDate: "01/04/2025",
    results: [
      {
        winningDigit: "23",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "41",
      },
    ],
  },
  {
    resultDate: "01/05/2025",
    results: [
      {
        winningDigit: "96",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "39",
      },
    ],
  },
  {
    resultDate: "01/06/2025",
    results: [
      {
        winningDigit: "02",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "15",
      },
    ],
  },
  {
    resultDate: "01/07/2025",
    results: [
      {
        winningDigit: "16",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "05",
      },
    ],
  },
  {
    resultDate: "01/08/2025",
    results: [
      {
        winningDigit: "72",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "14",
      },
    ],
  },
  {
    resultDate: "01/09/2025",
    results: [
      {
        winningDigit: "91",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "16",
      },
    ],
  },
  {
    resultDate: "01/10/2025",
    results: [
      {
        winningDigit: "13",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "04",
      },
    ],
  },
  {
    resultDate: "01/11/2025",
    results: [
      {
        winningDigit: "06",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "95",
      },
    ],
  },
  {
    resultDate: "01/12/2025",
    results: [
      {
        winningDigit: "26",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "69",
      },
    ],
  },
  {
    resultDate: "01/13/2025",
    results: [
      {
        winningDigit: "07",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "52",
      },
    ],
  },
  {
    resultDate: "01/14/2025",
    results: [
      {
        winningDigit: "55",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "93",
      },
    ],
  },
  {
    resultDate: "01/15/2025",
    results: [
      {
        winningDigit: "80",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "45",
      },
    ],
  },
  {
    resultDate: "01/16/2025",
    results: [
      {
        winningDigit: "41",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "63",
      },
    ],
  },
  {
    resultDate: "01/17/2025",
    results: [
      {
        winningDigit: "10",
      },
      {
        winningDigit: "33",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "78",
      },
    ],
  },
  {
    resultDate: "01/18/2025",
    results: [
      {
        winningDigit: "28",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "11",
      },
    ],
  },
  {
    resultDate: "01/19/2025",
    results: [
      {
        winningDigit: "31",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "70",
      },
    ],
  },
  {
    resultDate: "01/20/2025",
    results: [
      {
        winningDigit: "62",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "84",
      },
    ],
  },
  {
    resultDate: "01/21/2025",
    results: [
      {
        winningDigit: "86",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "41",
      },
    ],
  },
  {
    resultDate: "01/22/2025",
    results: [
      {
        winningDigit: "60",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "63",
      },
    ],
  },
  {
    resultDate: "01/23/2025",
    results: [
      {
        winningDigit: "43",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "08",
      },
    ],
  },
  {
    resultDate: "01/24/2025",
    results: [
      {
        winningDigit: "82",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "62",
      },
    ],
  },
  {
    resultDate: "01/25/2025",
    results: [
      {
        winningDigit: "29",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "02",
      },
    ],
  },
  {
    resultDate: "01/26/2025",
    results: [
      {
        winningDigit: "01",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "18",
      },
    ],
  },
  {
    resultDate: "01/27/2025",
    results: [
      {
        winningDigit: "42",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "15",
      },
    ],
  },
  {
    resultDate: "01/28/2025",
    results: [
      {
        winningDigit: "24",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "82",
      },
    ],
  },
  {
    resultDate: "01/29/2025",
    results: [
      {
        winningDigit: "08",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "28",
      },
    ],
  },
  {
    resultDate: "01/30/2025",
    results: [
      {
        winningDigit: "15",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "90",
      },
    ],
  },
  {
    resultDate: "01/31/2025",
    results: [
      {
        winningDigit: "34",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "57",
      },
    ],
  },
  {
    resultDate: "02/01/2025",
    results: [
      {
        winningDigit: "87",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "98",
      },
    ],
  },
  {
    resultDate: "02/02/2025",
    results: [
      {
        winningDigit: "23",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "67",
      },
    ],
  },
  {
    resultDate: "02/03/2025",
    results: [
      {
        winningDigit: "35",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "40",
      },
    ],
  },
  {
    resultDate: "02/04/2025",
    results: [
      {
        winningDigit: "02",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "14",
      },
    ],
  },
  {
    resultDate: "02/05/2025",
    results: [
      {
        winningDigit: "26",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "70",
      },
    ],
  },
  {
    resultDate: "02/06/2025",
    results: [
      {
        winningDigit: "92",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "45",
      },
    ],
  },
  {
    resultDate: "02/07/2025",
    results: [
      {
        winningDigit: "15",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "21",
      },
    ],
  },
  {
    resultDate: "02/08/2025",
    results: [
      {
        winningDigit: "57",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "63",
      },
    ],
  },
  {
    resultDate: "02/09/2025",
    results: [
      {
        winningDigit: "48",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "54",
      },
    ],
  },
  {
    resultDate: "02/10/2025",
    results: [
      {
        winningDigit: "62",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "26",
      },
    ],
  },
  {
    resultDate: "02/11/2025",
    results: [
      {
        winningDigit: "07",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "42",
      },
    ],
  },
  {
    resultDate: "02/12/2025",
    results: [
      {
        winningDigit: "10",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "57",
      },
    ],
  },
  {
    resultDate: "02/13/2025",
    results: [
      {
        winningDigit: "21",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "73",
      },
    ],
  },
  {
    resultDate: "02/14/2025",
    results: [
      {
        winningDigit: "93",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "38",
      },
    ],
  },
  {
    resultDate: "02/15/2025",
    results: [
      {
        winningDigit: "13",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "47",
      },
    ],
  },
  {
    resultDate: "02/16/2025",
    results: [
      {
        winningDigit: "35",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "57",
      },
    ],
  },
  {
    resultDate: "02/17/2025",
    results: [
      {
        winningDigit: "20",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "91",
      },
    ],
  },
  {
    resultDate: "02/18/2025",
    results: [
      {
        winningDigit: "95",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "72",
      },
    ],
  },
  {
    resultDate: "02/19/2025",
    results: [
      {
        winningDigit: "12",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "86",
      },
    ],
  },
  {
    resultDate: "02/20/2025",
    results: [
      {
        winningDigit: "23",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "68",
      },
    ],
  },
  {
    resultDate: "02/21/2025",
    results: [
      {
        winningDigit: "70",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "33",
      },
      {
        winningDigit: "96",
      },
    ],
  },
  {
    resultDate: "02/22/2025",
    results: [
      {
        winningDigit: "19",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "75",
      },
    ],
  },
  {
    resultDate: "02/23/2025",
    results: [
      {
        winningDigit: "72",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "67",
      },
    ],
  },
  {
    resultDate: "02/24/2025",
    results: [
      {
        winningDigit: "17",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "64",
      },
    ],
  },
  {
    resultDate: "02/25/2025",
    results: [
      {
        winningDigit: "09",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "38",
      },
    ],
  },
  {
    resultDate: "02/26/2025",
    results: [
      {
        winningDigit: "14",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "46",
      },
    ],
  },
  {
    resultDate: "02/27/2025",
    results: [
      {
        winningDigit: "36",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "70",
      },
    ],
  },
  {
    resultDate: "02/28/2025",
    results: [
      {
        winningDigit: "19",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "27",
      },
    ],
  },
  {
    resultDate: "03/01/2025",
    results: [
      {
        winningDigit: "63",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "54",
      },
    ],
  },
  {
    resultDate: "03/02/2025",
    results: [
      {
        winningDigit: "10",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "26",
      },
    ],
  },
  {
    resultDate: "03/03/2025",
    results: [
      {
        winningDigit: "32",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "73",
      },
    ],
  },
  {
    resultDate: "03/04/2025",
    results: [
      {
        winningDigit: "40",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "81",
      },
    ],
  },
  {
    resultDate: "03/05/2025",
    results: [
      {
        winningDigit: "85",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "32",
      },
    ],
  },
  {
    resultDate: "03/06/2025",
    results: [
      {
        winningDigit: "09",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "14",
      },
    ],
  },
  {
    resultDate: "03/07/2025",
    results: [
      {
        winningDigit: "52",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "41",
      },
    ],
  },
  {
    resultDate: "03/08/2025",
    results: [
      {
        winningDigit: "14",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "30",
      },
    ],
  },
  {
    resultDate: "03/09/2025",
    results: [
      {
        winningDigit: "67",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "89",
      },
    ],
  },
  {
    resultDate: "03/10/2025",
    results: [
      {
        winningDigit: "01",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "63",
      },
    ],
  },
  {
    resultDate: "03/11/2025",
    results: [
      {
        winningDigit: "95",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "06",
      },
    ],
  },
  {
    resultDate: "03/12/2025",
    results: [
      {
        winningDigit: "81",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "16",
      },
    ],
  },
  {
    resultDate: "03/13/2025",
    results: [
      {
        winningDigit: "68",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "85",
      },
    ],
  },
  {
    resultDate: "03/14/2025",
    results: [
      {
        winningDigit: "74",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "41",
      },
    ],
  },
  {
    resultDate: "03/15/2025",
    results: [
      {
        winningDigit: "87",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "04",
      },
    ],
  },
  {
    resultDate: "03/16/2025",
    results: [
      {
        winningDigit: "06",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "82",
      },
    ],
  },
  {
    resultDate: "03/17/2025",
    results: [
      {
        winningDigit: "10",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "75",
      },
    ],
  },
  {
    resultDate: "03/18/2025",
    results: [
      {
        winningDigit: "11",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "51",
      },
    ],
  },
  {
    resultDate: "03/19/2025",
    results: [
      {
        winningDigit: "84",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "07",
      },
    ],
  },
  {
    resultDate: "03/20/2025",
    results: [
      {
        winningDigit: "78",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "12",
      },
    ],
  },
  {
    resultDate: "03/21/2025",
    results: [
      {
        winningDigit: "18",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "97",
      },
    ],
  },
  {
    resultDate: "03/22/2025",
    results: [
      {
        winningDigit: "06",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "77",
      },
    ],
  },
  {
    resultDate: "03/23/2025",
    results: [
      {
        winningDigit: "49",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "28",
      },
    ],
  },
  {
    resultDate: "03/24/2025",
    results: [
      {
        winningDigit: "37",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "53",
      },
    ],
  },
  {
    resultDate: "03/25/2025",
    results: [
      {
        winningDigit: "21",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "32",
      },
    ],
  },
  {
    resultDate: "03/26/2025",
    results: [
      {
        winningDigit: "71",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "16",
      },
    ],
  },
  {
    resultDate: "03/27/2025",
    results: [
      {
        winningDigit: "13",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "55",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "85",
      },
    ],
  },
  {
    resultDate: "03/28/2025",
    results: [
      {
        winningDigit: "53",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "18",
      },
    ],
  },
  {
    resultDate: "03/29/2025",
    results: [
      {
        winningDigit: "04",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "27",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "44",
      },
    ],
  },
  {
    resultDate: "03/30/2025",
    results: [
      {
        winningDigit: "98",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "21",
      },
    ],
  },
  {
    resultDate: "03/31/2025",
    results: [
      {
        winningDigit: "65",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "75",
      },
    ],
  },
  {
    resultDate: "04/01/2025",
    results: [
      {
        winningDigit: "79",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "42",
      },
    ],
  },
  {
    resultDate: "04/02/2025",
    results: [
      {
        winningDigit: "53",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "19",
      },
    ],
  },
  {
    resultDate: "04/03/2025",
    results: [
      {
        winningDigit: "35",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "21",
      },
    ],
  },
  {
    resultDate: "04/04/2025",
    results: [
      {
        winningDigit: "18",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "89",
      },
    ],
  },
  {
    resultDate: "04/05/2025",
    results: [
      {
        winningDigit: "07",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "12",
      },
    ],
  },
  {
    resultDate: "04/06/2025",
    results: [
      {
        winningDigit: "90",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "68",
      },
    ],
  },
  {
    resultDate: "04/07/2025",
    results: [
      {
        winningDigit: "04",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "91",
      },
    ],
  },
  {
    resultDate: "04/08/2025",
    results: [
      {
        winningDigit: "13",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "79",
      },
    ],
  },
  {
    resultDate: "04/09/2025",
    results: [
      {
        winningDigit: "56",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "12",
      },
    ],
  },
  {
    resultDate: "04/10/2025",
    results: [
      {
        winningDigit: "23",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "80",
      },
    ],
  },
  {
    resultDate: "04/11/2025",
    results: [
      {
        winningDigit: "11",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "86",
      },
    ],
  },
  {
    resultDate: "04/12/2025",
    results: [
      {
        winningDigit: "06",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "54",
      },
    ],
  },
  {
    resultDate: "04/13/2025",
    results: [
      {
        winningDigit: "29",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "98",
      },
    ],
  },
  {
    resultDate: "04/14/2025",
    results: [
      {
        winningDigit: "15",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "62",
      },
    ],
  },
  {
    resultDate: "04/15/2025",
    results: [
      {
        winningDigit: "43",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "85",
      },
    ],
  },
  {
    resultDate: "04/16/2025",
    results: [
      {
        winningDigit: "07",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "72",
      },
    ],
  },
  {
    resultDate: "04/17/2025",
    results: [
      {
        winningDigit: "18",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "58",
      },
    ],
  },
  {
    resultDate: "04/18/2025",
    results: [
      {
        winningDigit: "50",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "87",
      },
    ],
  },
  {
    resultDate: "04/19/2025",
    results: [
      {
        winningDigit: "28",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "46",
      },
    ],
  },
  {
    resultDate: "04/20/2025",
    results: [
      {
        winningDigit: "31",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "04",
      },
    ],
  },
  {
    resultDate: "04/21/2025",
    results: [
      {
        winningDigit: "15",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "82",
      },
    ],
  },
  {
    resultDate: "04/22/2025",
    results: [
      {
        winningDigit: "02",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "31",
      },
    ],
  },
  {
    resultDate: "04/23/2025",
    results: [
      {
        winningDigit: "11",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "75",
      },
    ],
  },
  {
    resultDate: "04/24/2025",
    results: [
      {
        winningDigit: "35",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "96",
      },
    ],
  },
  {
    resultDate: "04/25/2025",
    results: [
      {
        winningDigit: "68",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "72",
      },
    ],
  },
  {
    resultDate: "04/26/2025",
    results: [
      {
        winningDigit: "95",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "67",
      },
    ],
  },
  {
    resultDate: "04/27/2025",
    results: [
      {
        winningDigit: "25",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "82",
      },
    ],
  },
  {
    resultDate: "04/28/2025",
    results: [
      {
        winningDigit: "51",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "66",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "31",
      },
    ],
  },
  {
    resultDate: "04/29/2025",
    results: [
      {
        winningDigit: "03",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "77",
      },
    ],
  },
  {
    resultDate: "04/30/2025",
    results: [
      {
        winningDigit: "13",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "48",
      },
    ],
  },
  {
    resultDate: "05/01/2025",
    results: [
      {
        winningDigit: "26",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "90",
      },
    ],
  },
  {
    resultDate: "05/02/2025",
    results: [
      {
        winningDigit: "32",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "48",
      },
    ],
  },
  {
    resultDate: "05/03/2025",
    results: [
      {
        winningDigit: "18",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "19",
      },
    ],
  },
  {
    resultDate: "05/04/2025",
    results: [
      {
        winningDigit: "26",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "81",
      },
    ],
  },
  {
    resultDate: "05/05/2025",
    results: [
      {
        winningDigit: "01",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "32",
      },
    ],
  },
  {
    resultDate: "05/06/2025",
    results: [
      {
        winningDigit: "48",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "43",
      },
    ],
  },
  {
    resultDate: "05/07/2025",
    results: [
      {
        winningDigit: "26",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "11",
      },
    ],
  },
  {
    resultDate: "05/08/2025",
    results: [
      {
        winningDigit: "37",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "97",
      },
    ],
  },
  {
    resultDate: "05/09/2025",
    results: [
      {
        winningDigit: "89",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "98",
      },
    ],
  },
  {
    resultDate: "05/10/2025",
    results: [
      {
        winningDigit: "17",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "49",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "08",
      },
    ],
  },
  {
    resultDate: "05/11/2025",
    results: [
      {
        winningDigit: "02",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "39",
      },
    ],
  },
  {
    resultDate: "05/12/2025",
    results: [
      {
        winningDigit: "25",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "39",
      },
    ],
  },
  {
    resultDate: "05/13/2025",
    results: [
      {
        winningDigit: "18",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "85",
      },
    ],
  },
  {
    resultDate: "05/14/2025",
    results: [
      {
        winningDigit: "32",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "25",
      },
    ],
  },
  {
    resultDate: "05/15/2025",
    results: [
      {
        winningDigit: "04",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "68",
      },
    ],
  },
  {
    resultDate: "05/16/2025",
    results: [
      {
        winningDigit: "15",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "01",
      },
    ],
  },
  {
    resultDate: "05/17/2025",
    results: [
      {
        winningDigit: "47",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "71",
      },
    ],
  },
  {
    resultDate: "05/18/2025",
    results: [
      {
        winningDigit: "53",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "01",
      },
    ],
  },
  {
    resultDate: "05/19/2025",
    results: [
      {
        winningDigit: "06",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "13",
      },
    ],
  },
  {
    resultDate: "05/20/2025",
    results: [
      {
        winningDigit: "31",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "26",
      },
    ],
  },
  {
    resultDate: "05/21/2025",
    results: [
      {
        winningDigit: "20",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "74",
      },
    ],
  },
  {
    resultDate: "05/22/2025",
    results: [
      {
        winningDigit: "46",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "22",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "37",
      },
    ],
  },
  {
    resultDate: "05/23/2025",
    results: [
      {
        winningDigit: "16",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "04",
      },
    ],
  },
  {
    resultDate: "05/24/2025",
    results: [
      {
        winningDigit: "47",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "85",
      },
    ],
  },
  {
    resultDate: "05/25/2025",
    results: [
      {
        winningDigit: "82",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "76",
      },
    ],
  },
  {
    resultDate: "05/26/2025",
    results: [
      {
        winningDigit: "01",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "65",
      },
    ],
  },
  {
    resultDate: "05/27/2025",
    results: [
      {
        winningDigit: "29",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "73",
      },
    ],
  },
  {
    resultDate: "05/28/2025",
    results: [
      {
        winningDigit: "63",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "83",
      },
      {
        winningDigit: "17",
      },
    ],
  },
  {
    resultDate: "05/29/2025",
    results: [
      {
        winningDigit: "07",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "73",
      },
    ],
  },
  {
    resultDate: "05/30/2025",
    results: [
      {
        winningDigit: "81",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "03",
      },
    ],
  },
  {
    resultDate: "05/31/2025",
    results: [
      {
        winningDigit: "53",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "17",
      },
    ],
  },
  {
    resultDate: "06/01/2025",
    results: [
      {
        winningDigit: "54",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "35",
      },
    ],
  },
  {
    resultDate: "06/02/2025",
    results: [
      {
        winningDigit: "70",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "62",
      },
    ],
  },
  {
    resultDate: "06/03/2025",
    results: [
      {
        winningDigit: "31",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "67",
      },
    ],
  },
  {
    resultDate: "06/04/2025",
    results: [
      {
        winningDigit: "51",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "55",
      },
    ],
  },
  {
    resultDate: "06/05/2025",
    results: [
      {
        winningDigit: "11",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "44",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "07",
      },
    ],
  },
  {
    resultDate: "06/06/2025",
    results: [
      {
        winningDigit: "48",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "31",
      },
    ],
  },
  {
    resultDate: "06/07/2025",
    results: [
      {
        winningDigit: "51",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "64",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "15",
      },
    ],
  },
  {
    resultDate: "06/08/2025",
    results: [
      {
        winningDigit: "36",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "97",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "65",
      },
    ],
  },
  {
    resultDate: "06/09/2025",
    results: [
      {
        winningDigit: "67",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "05",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "97",
      },
    ],
  },
  {
    resultDate: "06/10/2025",
    results: [
      {
        winningDigit: "87",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "38",
      },
      {
        winningDigit: "74",
      },
    ],
  },
  {
    resultDate: "06/11/2025",
    results: [
      {
        winningDigit: "95",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "57",
      },
    ],
  },
  {
    resultDate: "06/12/2025",
    results: [
      {
        winningDigit: "84",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "99",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "21",
      },
    ],
  },
  {
    resultDate: "06/13/2025",
    results: [
      {
        winningDigit: "67",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "62",
      },
    ],
  },
  {
    resultDate: "06/14/2025",
    results: [
      {
        winningDigit: "35",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "19",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "50",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "13",
      },
    ],
  },
  {
    resultDate: "06/15/2025",
    results: [
      {
        winningDigit: "32",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "55",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "14",
      },
    ],
  },
  {
    resultDate: "06/16/2025",
    results: [
      {
        winningDigit: "40",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "77",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "56",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "05",
      },
    ],
  },
  {
    resultDate: "06/17/2025",
    results: [
      {
        winningDigit: "37",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "88",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "97",
      },
    ],
  },
  {
    resultDate: "06/18/2025",
    results: [
      {
        winningDigit: "21",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "11",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "89",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "34",
      },
    ],
  },
  {
    resultDate: "06/19/2025",
    results: [
      {
        winningDigit: "54",
      },
      {
        winningDigit: "16",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "63",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "03",
      },
      {
        winningDigit: "46",
      },
    ],
  },
  {
    resultDate: "06/20/2025",
    results: [
      {
        winningDigit: "01",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "67",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "86",
      },
    ],
  },
  {
    resultDate: "06/21/2025",
    results: [
      {
        winningDigit: "12",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "76",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "69",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "37",
      },
    ],
  },
  {
    resultDate: "06/22/2025",
    results: [
      {
        winningDigit: "73",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "18",
      },
      {
        winningDigit: "00",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "08",
      },
    ],
  },
  {
    resultDate: "06/23/2025",
    results: [
      {
        winningDigit: "10",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "98",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "83",
      },
    ],
  },
  {
    resultDate: "06/24/2025",
    results: [
      {
        winningDigit: "67",
      },
      {
        winningDigit: "48",
      },
      {
        winningDigit: "17",
      },
      {
        winningDigit: "86",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "29",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "93",
      },
    ],
  },
  {
    resultDate: "06/25/2025",
    results: [
      {
        winningDigit: "01",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "39",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "90",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "67",
      },
    ],
  },
  {
    resultDate: "06/26/2025",
    results: [
      {
        winningDigit: "37",
      },
      {
        winningDigit: "80",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "52",
      },
    ],
  },
  {
    resultDate: "06/27/2025",
    results: [
      {
        winningDigit: "70",
      },
      {
        winningDigit: "59",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "23",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "67",
      },
    ],
  },
  {
    resultDate: "06/28/2025",
    results: [
      {
        winningDigit: "82",
      },
      {
        winningDigit: "75",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "61",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "13",
      },
      {
        winningDigit: "68",
      },
      {
        winningDigit: "71",
      },
      {
        winningDigit: "37",
      },
    ],
  },
  {
    resultDate: "06/29/2025",
    results: [
      {
        winningDigit: "45",
      },
      {
        winningDigit: "25",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "32",
      },
      {
        winningDigit: "72",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "93",
      },
      {
        winningDigit: "21",
      },
      {
        winningDigit: "92",
      },
      {
        winningDigit: "36",
      },
    ],
  },
  {
    resultDate: "06/30/2025",
    results: [
      {
        winningDigit: "64",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "14",
      },
      {
        winningDigit: "87",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "73",
      },
      {
        winningDigit: "84",
      },
      {
        winningDigit: "58",
      },
      {
        winningDigit: "46",
      },
      {
        winningDigit: "31",
      },
    ],
  },
  {
    resultDate: "07/01/2025",
    results: [
      {
        winningDigit: "35",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "24",
      },
      {
        winningDigit: "40",
      },
      {
        winningDigit: "20",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "01",
      },
      {
        winningDigit: "35",
      },
      {
        winningDigit: "71",
      },
    ],
  },
  {
    resultDate: "07/02/2025",
    results: [
      {
        winningDigit: "70",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "95",
      },
      {
        winningDigit: "30",
      },
      {
        winningDigit: "52",
      },
      {
        winningDigit: "82",
      },
      {
        winningDigit: "41",
      },
      {
        winningDigit: "54",
      },
      {
        winningDigit: "28",
      },
      {
        winningDigit: "04",
      },
      {
        winningDigit: "45",
      },
    ],
  },
  {
    resultDate: "07/03/2025",
    results: [
      {
        winningDigit: "23",
      },
      {
        winningDigit: "08",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "78",
      },
      {
        winningDigit: "91",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "47",
      },
      {
        winningDigit: "15",
      },
      {
        winningDigit: "31",
      },
      {
        winningDigit: "09",
      },
    ],
  },
  {
    resultDate: "07/04/2025",
    results: [
      {
        winningDigit: "84",
      },
      {
        winningDigit: "74",
      },
      {
        winningDigit: "96",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "07",
      },
      {
        winningDigit: "37",
      },
      {
        winningDigit: "42",
      },
      {
        winningDigit: "12",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "60",
      },
      {
        winningDigit: "92",
      },
    ],
  },
  {
    resultDate: "07/05/2025",
    results: [
      {
        winningDigit: "46",
      },
      {
        winningDigit: "36",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "02",
      },
      {
        winningDigit: "57",
      },
      {
        winningDigit: "45",
      },
      {
        winningDigit: "53",
      },
      {
        winningDigit: "79",
      },
      {
        winningDigit: "10",
      },
      {
        winningDigit: "65",
      },
      {
        winningDigit: "09",
      },
      {
        winningDigit: "17",
      },
    ],
  },
  {
    resultDate: "07/06/2025",
    results: [
      {
        winningDigit: "18",
      },
      {
        winningDigit: "26",
      },
      {
        winningDigit: "94",
      },
      {
        winningDigit: "34",
      },
      {
        winningDigit: "06",
      },
      {
        winningDigit: "43",
      },
      {
        winningDigit: "85",
      },
      {
        winningDigit: "51",
      },
      {
        winningDigit: "62",
      },
      {
        winningDigit: "81",
      },
      {
        winningDigit: "70",
      },
      {
        winningDigit: "41",
      },
    ],
  },
];
